import React, { useState, useRef } from "react"
import styled from "styled-components"
// ✅ reCAPTCHA
import ReCAPTCHA from "react-google-recaptcha"

import { medWrapper, headlineOne, bodyCopy, buttonOne } from "../../Utilities"

import InputText from "../allSite/formParts/InputText"
import InputTextArea from "../allSite/formParts/InputTextArea"
import { submitTheForm } from "../allSite/formParts/FormUtilities/formFunctions"

// models //
import SubmitDisplay from "../allSite/formParts/FormUtilities/SubmitDisplay"
import ErrorDisplay from "../allSite/formParts/FormUtilities/ErrorDisplay"
import SuccessFeedback from "../allSite/formParts/FormUtilities/SuccessFeedback"

const FeedbackSection = styled.section`
  margin: 3rem auto;
  .wrapper {
    ${medWrapper};

    background: #c3e6d7;

    @media (min-width: 768px) {
      padding: 5rem;
    }

    @media (min-width: 1025px) {
      padding: 10rem;
    }
  }

  .title {
    width: 100%;

    @media (min-width: 768px) {
      text-align: center;
    }

    h2 {
      ${headlineOne};
      color: #338383;
    }
  }

  .content {
    width: 100%;

    p {
      ${bodyCopy};
      color: #505b61;
    }
  }

  .button {
    width: 100%;

    a {
      ${buttonOne};
    }
  }

  .form {
    width: 100%;

    //  ✅ reCAPTCHA //
    .captcha-container {
      width: 100%;
      margin-top: 3rem;
      margin-bottom: 1rem;

      p {
        ${bodyCopy};
        margin: 0;
        margin-bottom: 0.75rem;
        color: red;
      }
    }

    .form-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      width: 100%;
    }

    .form-submit {
      margin-top: 2.5rem;

      button {
        ${buttonOne};
        display: inline-block;
        text-transform: uppercase;
      }
    }
  }
`

const Feedback = ({ data }) => {
  // ✅ reCAPTCHA
  const recaptchaRef = useRef(null)
  // ✅ reCAPTCHA
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false)

  const [formData, updateFormData] = useState({
    fbName: "",
    fbNumber: "",
    fbEmail: "",
    fbMessage: "",
  })

  // ✅ reCAPTCHA
  const [formStatus, updateFormStatus] = useState({
    submitting: false,
    errorWarnDisplay: false,
    success: false,
    errors: [],
    captachError: false,
  })

  // ✅ reCAPTCHA
  const onChangeRecaptcha = value => {
    setIsCaptchaVerified(!!value)

    updateFormStatus(prev => ({
      ...prev,
      captachError: false,
    }))
  }

  const handleOnChange = e => {
    updateFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleOnSubmit = (e, formId, formData, updateFormStatus) => {
    e.preventDefault()
    // ✅ reCAPTCHA
    const recaptchaValue = recaptchaRef.current.getValue()
    // ✅ reCAPTCHA
    if (recaptchaValue === "") {
      updateFormStatus({
        ...formStatus,
        captachError: true,
      })
      return
    }

    updateFormStatus({
      ...formStatus,
      submitting: true,
      captachError: false,
    })

    // ✅ reCAPTCHA
    submitTheForm(
      e,
      formId,
      formData,
      updateFormStatus,
      recaptchaRef,
      setIsCaptchaVerified
    )
  }

  const title = data.acf._adw_contact_feed_title
  const content = data.acf._adw_contact_feed_content
  const btnText = data.acf._adw_contact_feed_btn_text
  const btnUrl = data.acf._adw_contact_feed_btn_url
  return (
    <FeedbackSection>
      <div className="wrapper">
        <div className="title">
          <h2>{title}</h2>
        </div>
        <div className="content">
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
        <div className="button">
          <a target="_blank" rel="noopener noreferrer" href={btnUrl}>
            {btnText}
          </a>
        </div>
        <div className="form">
          <form
            onSubmit={e => {
              handleOnSubmit(e, 287, formData, updateFormStatus)
            }}
          >
            <div className="form-wrapper">
              <InputText
                name="fbName"
                type="text"
                placeholder="Your Full Name"
                label="Your Full Name"
                value={formData.fbName}
                onChange={handleOnChange}
                errors={formStatus.errors}
                required={false}
                width="half"
                formSide="left"
                textColor=""
              />
              <InputText
                name="fbNumber"
                type="text"
                placeholder="Phone"
                label="Phone"
                value={formData.fbNumber}
                onChange={handleOnChange}
                errors={formStatus.errors}
                required={false}
                width="half"
                formSide="right"
                textColor=""
              />
              <InputText
                name="fbEmail"
                type="email"
                placeholder="Email"
                label="Email"
                value={formData.fbEmail}
                onChange={handleOnChange}
                errors={formStatus.errors}
                required={false}
                width="full"
                formSide="full"
                textColor=""
              />
              <InputTextArea
                name="fbMessage"
                placeholder="Message"
                label="Message"
                value={formData.fbMessage}
                onChange={handleOnChange}
                errors={formStatus.errors}
                required={false}
                rows={5}
                textColor=""
              />
              {/*  ✅ reCAPTCHA */}
              <div className="captcha-container">
                {formStatus.captachError && (
                  <p>
                    The form will not submit until you have checked the
                    reCAPCHA.
                  </p>
                )}
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={`6LdC54QsAAAAAIp768v0Cgy620ypb8aoXcsNpLjA`}
                  onChange={onChangeRecaptcha}
                  onExpired={() => setIsCaptchaVerified(false)}
                />
              </div>
              {/*  ✅ reCAPTCHA */}
              <div className="form-submit">
                <button
                  disabled={!isCaptchaVerified || formStatus.submitting}
                  type="submit"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {formStatus.submitting && <SubmitDisplay />}
      {formStatus.errorWarnDisplay && (
        <ErrorDisplay formStatus={formStatus} stateSetter={updateFormStatus} />
      )}
      {formStatus.success && (
        <SuccessFeedback
          updateFormData={updateFormData}
          updateFormStatus={updateFormStatus}
        />
      )}
    </FeedbackSection>
  )
}

export default Feedback
